/**
* Cookie.ts
* @author Hector Hernandez (hectorh)
* @copyright Microsoft 2020
* JSLL Cookie.
*/
import { getCookieValue, safeGetCookieMgr } from "@microsoft/applicationinsights-core-js";
import { notImplementedWarn } from "./Utils";
var Cookie = /** @class */ (function () {
    function Cookie() {
    }
    Cookie.prototype.getCookie = function (name, valuePrefix) {
        return getCookieValue(safeGetCookieMgr(null), name);
    };
    Cookie.prototype.setCookie = function (name, value, days) {
        safeGetCookieMgr(null).set(name, value, days * 86400, null, "/");
    };
    Cookie.prototype.deleteCookie = function (name) {
        safeGetCookieMgr(null).del(name);
    };
    Cookie.prototype.getCookieKeyValue = function (cookieName, keyName) {
        // NO OP
        notImplementedWarn("getCookieKeyValue");
        return undefined;
    };
    Cookie.prototype.getAllCookies = function () {
        // NO OP
        notImplementedWarn("getAllCookies");
        return undefined;
    };
    return Cookie;
}());
export { Cookie };
//# sourceMappingURL=Cookie.js.map